// extracted by mini-css-extract-plugin
module.exports = {"badge":"nav_badge-module__badge___jExl9","outstanding":"nav_badge-module__outstanding___A425U","neutral":"nav_badge-module__neutral___196rF"};